import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useTheme } from '../ThemeContext.tsx'; // Import useTheme
import { Theme } from '../predefinedThemes'; // Import Theme interface

interface ChecklistProgressCardProps {
  title: string;
  progress: number;
}

function ChecklistProgressCard({ title, progress }: ChecklistProgressCardProps) {
  const { theme } = useTheme();
  const progressColor: string = progress === 100 ? theme.colors.greenSuccess : theme.colors.primaryRed;
  const textColor: string = progress === 100 ? theme.colors.greenSuccess : theme.colors.darkText;

  return (
    <Card
      className="checklist-progress-card" // Use the class defined in App.css
      sx={{
        width: '100%', // Allow card to take full width of its grid item
        textAlign: 'center',
        backgroundColor: theme.colors.taskCardBackground, // Changed to taskCardBackground
        borderRadius: theme.borderRadius,
        boxShadow: theme.boxShadow,
        border: `1px solid ${theme.colors.borderColor}`,
        display: 'flex', // Use flexbox for content alignment
        flexDirection: 'column', // Stack content vertically
        justifyContent: 'center', // Center content vertically
        alignItems: 'center', // Center content horizontally
        aspectRatio: '1 / 1', // Maintain square aspect ratio
        flexShrink: 1, // Allow the card to shrink
        boxSizing: 'border-box', // Ensure padding and border are included in the width
      }}
    >
      <CardContent sx={{ 
        p: 1, 
        flexGrow: 1, 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center',
        width: '100%', // Ensure CardContent takes full width of its parent
        height: '100%', // Ensure CardContent takes full height of its parent
        boxSizing: 'border-box', // Ensure padding and border are included in the width/height
      }}>
        <div style={{ width: '60%', height: '60%', margin: '0 auto 16px', flexShrink: 1 }}> {/* Adjusted size for circular progress bar, added flexShrink and increased bottom margin */}
          <CircularProgressbar
            value={progress}
            text={`${progress}%`}
            styles={buildStyles({
              pathColor: progressColor,
              textColor: textColor,
              trailColor: theme.colors.borderColor,
              backgroundColor: 'transparent',
            })}
          />
        </div>
        <Typography variant="body1" component="div" sx={{ color: theme.colors.darkText, fontWeight: 'bold', fontSize: '0.9rem', flexShrink: 1 }}> {/* Changed text color to darkText */}
          {title}
        </Typography>
        <Typography variant="caption" sx={{ color: theme.colors.lightText, fontSize: '0.7rem', flexShrink: 1 }}> {/* Kept lightText */}
          {progress}% completed
        </Typography>
      </CardContent>
    </Card>
  );
}

export default ChecklistProgressCard;
